// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

// Mirrors `enums.BillingTiming` on the BE. ADVANCE bills at the start
// of the invoice period covering the charge; ARREARS bills at the
// end. Used by cascade math + the in-drawer schedule preview.
export const invoiceModeSchema = caseInsensitiveEnum(['ADVANCE', 'ARREARS']);

export type InvoiceMode = z.infer<typeof invoiceModeSchema>;

export const INVOICE_MODE = {
  ADVANCE: 'ADVANCE',
  ARREARS: 'ARREARS',
} as const satisfies Record<InvoiceMode, InvoiceMode>;
